var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__online"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#DAFD82",
    d: "M11.196,32c1.77,0,3.199-1.421,3.199-3.182c0-1.752-1.43-3.188-3.199-3.188 c-1.763,0-3.195,1.437-3.195,3.188C7.999,30.579,9.432,32,11.196,32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#FFFFFF",
    d: "M27.383,31.992h4.616C31.999,18.767,21.233,8,8.001,8v4.601 C18.687,12.601,27.383,21.301,27.383,31.992z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#FFFFFF",
    d: "M19.227,31.993h4.621c0-8.734-7.11-15.839-15.847-15.839v4.6c2.997,0,5.813,1.17,7.935,3.292 C18.058,26.162,19.227,28.989,19.227,31.993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorOnline);
export default __webpack_public_path__ + "static/media/color-online.c3f166aeb3304e3ada034097d3f7b0be.svg";
export { ForwardRef as ReactComponent };